import { toast } from '@goodrx/matisse';

export default class Alert {
  static success(message: any) {
    toast.success(message, {
      position: 'bottom-left',
    });
  }

  static error(message: any) {
    toast.error(message, {
      position: 'bottom-left',
    });
  }
}
